
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";

interface DialogFooterActionsProps {
  onCancel: () => void;
}

const DialogFooterActions = ({ onCancel }: DialogFooterActionsProps) => {
  return (
    <DialogFooter>
      <Button variant="outline" type="button" onClick={onCancel}>Cancel</Button>
      <Button type="submit">Save changes</Button>
    </DialogFooter>
  );
};

export default DialogFooterActions;
